var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jdi-content',{attrs:{"title":"Form layout"}},[_c('p',[_vm._v("To lay out a form...")])])}
var staticRenderFns = []

export { render, staticRenderFns }